import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentOrganizationEffects } from './store/tellent-organization.effects';
import {
  TellentOrganizationNamespace,
  TellentOrganizationReducer,
} from './store/tellent-organization.store';

const provideTellentOrganizationState = provideState(
  TellentOrganizationNamespace,
  TellentOrganizationReducer,
);
const provideTellentOrganizationEffects = provideEffects(TellentOrganizationEffects);

export const tellentOrganizationData = [
  provideTellentOrganizationState,
  provideTellentOrganizationEffects,
];
